import React, { useMemo } from "react";
import styles from "./index.module.scss";
import classNames from "classnames";
import { Spacer } from "./Component/Spacer";

interface SpacerProps {
    className?: string;
    align?: "start" | "end" | "center";
    direction?: "vertical" | "horizontal";
    size?: number;
    children: React.ReactNode;
    split?: React.ReactNode;
}

export default function Space({
    className,
    children,
    split,
    size = 8,
    direction = "horizontal",
    align
}: SpacerProps) {
    const childArr = useMemo(
        () => React.Children.toArray(children),
        [children]
    );

    const alignStyle = useMemo(() => {
        if (align === "start") return "flex-start";
        if (align === "end") return "flex-end";
        if (align === "center") return "center";
        return direction === "vertical" ? "" : "center";
    }, [align, direction]);

    return (
        <div
            style={{
                gap: size,
                alignItems: alignStyle
            }}
            className={classNames(className, styles.root, [
                { [styles.vertical]: direction === "vertical" }
            ])}>
            {childArr.map((child, index) => (
                <React.Fragment key={index}>
                    {child}
                    {index < childArr.length - 1 && split}
                </React.Fragment>
            ))}
        </div>
    );
}

Space.Spacer = Spacer;
